/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetInstrumentScopeRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/SetInstrumentScope.pb'
import {SetInstrumentScopeResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/SetInstrumentScope.pb'


export const setInstrumentScope = (request: SetInstrumentScopeRequest, options?: CashRequestOptions) => post<SetInstrumentScopeRequest, SetInstrumentScopeResponse>("/2.0/cash/set-instrument-scope", request, {...options, rejectOnError: true })